import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useState, useMemo } from 'react';
import { Paper } from '@mui/material';
import DisplayOnlyField from './fields/DisplayOnlyField';
import HistoryTooltip from './fields/HistoryTooltip';

export default function MuiAUtocomplete({
  options,
  dataCy,
  multiple,
  wrapperClasses,
  label,
  onChange,
  value,
  format,
  defaultFormat,
  inputValue,
  onInputChange,
  handleNoOption,
  disabled,
  displayOnly,
  withHistory,
  history = [],
}) {
  if (defaultFormat) format = { value: 'id', label: 'name' };

  // Memoize formatted options to prevent unnecessary re-renders
  const formatedOptions = useMemo(() => {
    if (options && Array.isArray(options) && options.length > 0) {
      return format
        ? options.map((d) => ({
            value: d[format?.value],
            label: d[format?.label],
          }))
        : options;
    }
    return [];
  }, [options, format]);

  const [defaultSelect, setDefaultSelect] = React.useState(null);

  React.useEffect(() => {
    if (multiple) {
      if (value && Array.isArray(value) && value.length > 0) {
        setDefaultSelect(value);
      }
    } else {
      if (value && formatedOptions?.length > 0) {
        let d = formatedOptions?.find((o) => o.value === value);
        setDefaultSelect(d);
      }
    }
  }, [formatedOptions, value, multiple]);

  const resolveLabel = (val) => {
    return val?.label || defaultSelect?.label || '--';
  };

  const displayText = multiple
    ? (value || [])
        .map((v) => resolveLabel(v))
        .filter(Boolean)
        .join(', ')
    : resolveLabel(value);

  if (displayOnly || disabled) {
    return (
      <div className="flex items-center gap-2 w-full">
        <div className={`${wrapperClasses} flex-1`}>
          <DisplayOnlyField label={label} value={displayText} />
        </div>
        <HistoryTooltip show={withHistory} history={history} />
      </div>
    );
  }
  return (
    <div className={`${wrapperClasses} flex items-center gap-2 flex-1`}>
      <Autocomplete
        data-cy={dataCy}
        value={defaultSelect || (multiple ? [] : null)}
        onInputChange={onInputChange}
        onChange={onChange}
        disabled={disabled}
        multiple={multiple}
        id={dataCy}
        options={formatedOptions || []}
        noOptionsText={handleNoOption}
        fullWidth
        getOptionLabel={(option) => {
          if (!option) return '';
          return option?.label || option?.name || '';
        }}
        isOptionEqualToValue={(option, value) => {
          if (!option || !value) return false;
          return option?.value === value?.value;
        }}
        sx={{
          minWidth: 150,
          flex: 1,
          '& .MuiInputLabel-root': { color: 'green', borderColor: 'red' },
          '& .MuiInputBase-input': { color: 'green' },
          '& .MuiOutlinedInput-root': {},
          '& .MuiAutocomplete-option': {
            backgroundColor: 'red',
          },
        }}
        PaperComponent={(props) => (
          <Paper {...props} sx={{ backgroundColor: '#ffffff', zIndex: 9999 }}>
            {/* Your list content */}
          </Paper>
        )}
        slotProps={{
          paper: {
            sx: {
              zIndex: 9999,
            },
          },
          popper: {
            sx: {
              zIndex: 9999,
            },
          },
        }}
        renderInput={(params) => (
          <TextField
            InputProps={{
              'data-cy': `${dataCy}-input`,
              role: `${dataCy}-input`,
            }}
            {...params}
            label={label}
          />
        )}
      />
      <HistoryTooltip show={withHistory} history={history} />
    </div>
  );
}
